const customerUserMeterInfo = {
  state: {
    customerUserMeterInfos: [],
    batchRechargeAmount: 0
  },
  mutations: {
    SET_CUSTOMER_USER_METER_INFOS: (state, customerUserMeterInfos) => {
      state.customerUserMeterInfos = customerUserMeterInfos
    },
    SET_BATCH_CRECHARGE_AMOUNT: (state, batchRechargeAmount) => {
      state.batchRechargeAmount = batchRechargeAmount
    }
  }
}

export default customerUserMeterInfo
